import React from 'react';

export default function ChartCard({ title, subtitle, children, span }) {
  return (
    <div style={{ ...styles.card, gridColumn: span ? `span ${span}` : 'span 1' }}>
      <div style={styles.header}>
        <div>
          <div style={styles.title}>{title}</div>
          {subtitle && <div style={styles.sub}>{subtitle}</div>}
        </div>
      </div>
      <div style={styles.body}>{children}</div>
    </div>
  );
}

const styles = {
  card: {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius)',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 300,
    transition: 'background 0.25s, border-color 0.25s',
    boxShadow: 'var(--shadow-sm)',
  },
  header: { marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
  title:  { fontSize: 14, fontWeight: 600, color: 'var(--text)', letterSpacing: '-0.2px' },
  sub:    { fontSize: 11, color: 'var(--text3)', marginTop: 3 },
  body:   { flex: 1, display: 'flex', flexDirection: 'column' },
};
